const rxIndex = /\[(\d+)]/g

const unwrapSquareBrackets = s => s.replace(rxIndex, '.$1')

export const get = (obj, path, def) =>
  (typeof path === 'string' ? unwrapSquareBrackets(path).split('.') : path)
    .filter(Boolean)
    .every(step => (obj = obj[step]) !== undefined)
    ? obj
    : def
